import { render } from "./ThicknessAdjustmentSteelcase.vue?vue&type=template&id=490bd298&scoped=true"
import script from "./ThicknessAdjustmentSteelcase.vue?vue&type=script&lang=js"
export * from "./ThicknessAdjustmentSteelcase.vue?vue&type=script&lang=js"

import "./ThicknessAdjustmentSteelcase.vue?vue&type=style&index=0&id=490bd298&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490bd298"]])

export default __exports__